export const EMR_FETCH_PATIENT_SUMMARY_EVENT = "rcm-emr-fetch-patient-summary";

export const FIELD_SUMMARY_PROMPT = "Generate patient summary";

export function dispatchEmrFetchPatientSummary(): void {
  window.dispatchEvent(new CustomEvent(EMR_FETCH_PATIENT_SUMMARY_EVENT));
}
